export default __webpack_public_path__ + "static/media/communities and me.542e6279.png";